$(function() {

    if (!calendarConfiguration.loginUserId || calendarConfiguration.loginUserType === 'Anonymous') {
        return;
    }

    $(".loader").show(); // TODO This is bad. We show and hide this without coordination of any kind if multiple requests are running in parallel.
    $.ajax({
        headers: {
            'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
        },
        xhrFields: {withCredentials: true},
        type: "GET",
        dataType: "json",
        url: calendarConfiguration.apiHostName + "/profile/" + calendarConfiguration.loginUserId,
        contentType: "application/json; charset=utf-8",
        success: function (data) {
            $(".loader").hide(); // TODO See my comment above.
            profileConfiguration = data;
        },
        failure: function (msg) {
            alert("Failed loading user profile"); // TODO Proper error handling. Like showing an overlay with a refresh button.
        }
    });

});
